import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { RepositoryFactory } from "../../Repository/RepositoryFactory";
const SalaryRepository = RepositoryFactory.get("salary_repository");
import Loader from "../components/Loader";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DeleteDialog from "../reusableComponents/DeleteDialog";
import { Toast } from "../components/Toast";
import { Button, Grid } from "@mui/material";
import { TextField, Box, Stack, Typography, styled } from "@mui/material";
import Repo from "../../Repository/Repo";

const customStyles = {
  rows: {
    style: {
      minHeight: "60px",
    },
  },
  headCells: {
    style: {
      backgroundColor: "#4EAF50",
      color: "white",
      fontSize: "16px",
    },
  },
  cells: {
    style: {
      paddingLeft: "18px",
    },
  },
};

const BtnBack = styled(Button)({
  background: "#4EAF50 !important",
  textTransform: "none",
  color: "white",
  borderRadius: "6px",
  fontSize: "12px",
});

function SalaryHistory(props) {
  const companyCode = localStorage.getItem("companyCode");
  const [userHistory, setUserHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selected, setSelected] = useState("");

  useEffect(() => {
    getEmployeeHistory();
  }, []);

  const columns = [
    {
      name: "#",
      width: "50px",
      selector: (row, index) => index + 1,
    },

    {
      name: "Date",
      selector: (row) => row.date,
    },
    {
      name: "Total Salary",
      selector: (row) => row.totalSalary,
    },

    {
      name: " Paid Salary",
      selector: (row) => row.paid,
    },
    {
      name: "Balance",
      selector: (row) => row.remaining,
    },
    {
      name: "Actions",
      width: "100px",
      cell: (row, i) => (
        <DeleteForeverIcon
          sx={{ color: "red", fontSize: "35px", cursor: "pointer" }}
          onClick={() => handleDelete(i)}
        />
      ),
    },
  ];

  const handleDelete = (arg) => {
    setDeleteModal((prev) => !prev);
    setSelected(arg);
  };

  const getEmployeeHistory = async () => {
    setLoading(true);
    let { data } = await SalaryRepository.salaryModel({
      request: {
        method: "getHistoryByUser",
        data: {
          userId: props.location.state?.row?.userId,
          company_code: companyCode,
        },
      },
    });
    setUserHistory(data.response.data.historyArr);
    setLoading(false);
  };

  const deleteRecord = async () => {
    try {
      setLoading(true);
      setDeleteModal(false);
      let { data } = await Repo.salary({
        request: {
          method: "deleteSalaryHistory",
          data: {
            userId: props.location.state?.row?.userId,
            historyIndex: selected,
            company_code: localStorage.getItem("companyCode"),
          },
        },
      });
      setLoading(false);
      if (data.response.status.statusCode == 200) {
        Toast("success", "Deleted Successfully");
        getEmployeeHistory();
      } else {
        Toast("error", "Error");
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  return (
    <Box sx={{ mt: 5 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" spacing={2}>
          <Typography sx={{ color: "#4EAF50" }} variant="h6">
            {props.location.state.row.userName}
          </Typography>
          <Typography variant="h6" display="inline">
            Salary History
          </Typography>
        </Stack>
        <Link to="/inventory/admin/employee-salary">
          <BtnBack>Back</BtnBack>
        </Link>
      </Stack>

      <Box sx={{ mt: 5, mb: 1.5 }}>
        <Grid container spacing={2}>
          <Grid item lg={4} md={6} sm={12}>
            <Grid container spacing={2}>
              <Grid item lg={4} md={4} sm={4}>
                <Typography sx={{ pt: 1 }} variant="body1">
                  Joining Date:
                </Typography>
              </Grid>
              <Grid item lg={6} md={6} sm={6}>
                <TextField
                  disabled
                  size="small"
                  fullWidth
                  id="date"
                  type="date"
                  variant="outlined"
                  sx={{
                    borderRadius: "6px",
                    fontSize: "12px",
                    height: "40px",
                    lineHeight: "14.06px",
                    backgroundColor: "white",
                  }}
                  value={props.location.state?.row?.joiningDate}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={4} md={6} sm={12}>
            <Grid container spacing={2}>
              <Grid item lg={5} md={5} sm={5}>
                <Typography sx={{ pt: 1 }} variant="body1">
                  Monthly Salary:
                </Typography>
              </Grid>
              <Grid item lg={6} md={6} sm={6}>
                <TextField
                  disabled
                  size="small"
                  fullWidth
                  variant="outlined"
                  sx={{
                    borderRadius: "6px",
                    fontSize: "12px",
                    height: "40px",
                    lineHeight: "14.06px",
                    backgroundColor: "white",
                  }}
                  inputProps={{ style: { textAlign: "center" } }}
                  value={props.location.state?.row?.currentSalary}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <DataTable
        columns={columns}
        data={userHistory}
        customStyles={customStyles}
        pagination
      />

      <DeleteDialog
        title="Delete Salary"
        open={deleteModal}
        onClose={handleDelete}
        onClickYes={deleteRecord}
      />
      <Loader loading={loading} />
    </Box>
  );
}

export default SalaryHistory;
